// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css/bootstrap-3.3.7-dist/css/bootstrap.css'
import './assets/css/reset.css'
import './assets/css/custom.css'
import './assets/css/custom-fix.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import $ from 'jquery'
import axios from 'axios'

// axios.defaults.baseURL = 'http://192.168.0.67:9033/'
axios.defaults.baseURL = 'http://www.chargepop.net/api/'

axios.defaults.timeout = 10000
Vue.prototype.ajax = axios
Vue.config.productionTip = false
Vue.use(VueI18n)
const i18n = new VueI18n({
  // 语言标识
  locale: 'vi-VN',
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    // 中文语言包
    'zh-CN': require('./assets/lang/zh.json'),
    // 英文语言包
    'en-US': require('./assets/lang/en.json'),
    // 越南语言包
    'vi-VN': require('./assets/lang/vi.json'),
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js